import { useEffect, useState } from 'react'

import { useCommentsChannels } from '~publish/components/CommentsSidebar/useCommentsChannels'

import { useChannelCommentCounts } from '../pages/Comments/hooks/useChannelCommentCounts'

type UseUnrepliedCommentsCountResult = {
  totalCount: number
  loading: boolean
  error: Error | null
}

/**
 * Fetch unreplied counts *after* channels are ready
 */
export const useUnrepliedCommentsCount =
  (): UseUnrepliedCommentsCountResult => {
    const {
      channels,
      loading: channelsLoading,
      error: channelsError,
    } = useCommentsChannels()

    const [readyChannels, setReadyChannels] = useState<boolean>(false)

    // Wait for channels to be loaded
    useEffect(() => {
      if (
        !channelsLoading &&
        !channelsError &&
        Array.isArray(channels) &&
        channels.length > 0
      ) {
        setReadyChannels(true)
      }
    }, [channelsLoading, channelsError, channels])

    const {
      counts,
      loading: countsLoading,
      error: countsError,
    } = useChannelCommentCounts({
      channels: readyChannels ? channels : [],
      status: ['unreplied'],
    })

    const totalCount = counts?.reduce((sum, { count }) => sum + count, 0) || 0

    return {
      totalCount,
      loading: channelsLoading || countsLoading,
      error: channelsError || countsError,
    }
  }
